import format from "date-fns/fp/format";
import isToday from "date-fns/isToday";

const HHmm = format("HH:mm");
const yyyyMMddHHmm = format("yyyy-MM-dd HH:mm");

export function formatChatMessageDatetime(d: Date) {
  return isToday(d) ? HHmm(d) : yyyyMMddHHmm(d);
}
